module.exports = __webpack_public_path__ + "img/Астана қ..8545ecac.png";